import React, { Component } from 'react';


import  CertReqLegalFormPartial  from "./certreqlegalform";
import  CertReqMoralFormPartial  from "./certreqmoralform";
import  CertReqMoralInspectionFormPartial  from "./certreqmoralinspectionform";

class CertReqFormsPartial extends Component {
    constructor(props) {
        super(props);
        this.state = {  
           
        }
     
    }

    componentWillReceiveProps(newProps)
    {
       
    }
    
    render() { 


        const {mainmodel} = this.props;
        let model=mainmodel;

        let tabCounter=0;
        let pageCounter=0;
        console.log('88888MODEL888888',model) 

        console.log('PROPSSSS',this.props);

        return (  

            <div>
                                   
                <div className="row">
                    <div className="col-md-12">
                        <ul class="nav nav-tabs">
                        {model && model.CertificationLegalForms && model.CertificationLegalForms.map((frm)=> {
                             pageCounter=pageCounter+1;  
                             return <li className={`${pageCounter==1?'active':''} `}><a data-toggle="tab" href={`#frm-${frm.Id}`}>نظر پزشک</a></li>  
                        })}
                        {model && model.CertificationMoralForms && model.CertificationMoralForms.map((frm)=> {
                             pageCounter=pageCounter+1;  
                             return <li className={`${pageCounter==1?'active':''} `}><a data-toggle="tab" href={`#frm-${frm.Id}`}>گواهی فوت</a></li>  
                        })}
                         {/*model && model.CertificationMoralInspectionForms && model.CertificationMoralInspectionForms.map((frm)=> {
                             pageCounter=pageCounter+1;  
                             return <li className={`${pageCounter==1?'active':''} `}><a data-toggle="tab" href={`#frm-${frm.Id}`}>معاینه جسد</a></li>  
                        })*/}

                        </ul>

                        <div class="tab-content">
                            {model && model.CertificationLegalForms && model.CertificationLegalForms.map((frm,i)=>{
                             tabCounter=tabCounter+1;  
                             return   <div id={`frm-${frm.Id}`} className={`tab-pane fade in ${tabCounter==1?'active':''} `}>
                                            <CertReqLegalFormPartial  form={frm} {...this.props}></CertReqLegalFormPartial>
                                      </div>  
                            })}

                            {model && model.CertificationMoralForms && model.CertificationMoralForms.map((frm,i)=>{
                            tabCounter=tabCounter+1;  
                            return   <div id={`frm-${frm.Id}`}  className={`tab-pane fade in ${tabCounter==1?'active':''} `}>
                                            <CertReqMoralFormPartial  form={frm} {...this.props}></CertReqMoralFormPartial>
                                      </div>  
                            })}

                            {/*model && model.CertificationMoralInspectionForms && model.CertificationMoralInspectionForms.map((frm,i)=>{
                            tabCounter=tabCounter+1;  
                            return   <div id={`frm-${frm.Id}`}  className={`tab-pane fade in ${tabCounter==1?'active':''} `}>
                                            <CertReqMoralInspectionFormPartial  form={frm} {...this.props}></CertReqMoralInspectionFormPartial>
                                      </div>  
                            })*/}
                            
                        </div>
                            
                    </div>           
                </div>

            </div>
  
        );
    }
}
 
export default CertReqFormsPartial;